import { etlPageView } from '@utils/ETL'

export const afterEach = (to: any) => {
  etlPageView({
    code: '',
    globalPost: true,
    pageId: to.fullPath
  })
}
